module.exports = __webpack_public_path__ + "assets/img/head2-zh.a2748361.png";